import { css } from '@emotion/react';
import { AnimationPulse } from 'styles/animations';

export const Header = ({ children }) => {
	return (
		<div
			css={css`
				// background: #fafaff;
				box-shadow: inset 0 -1px 0 0 #f0f0ff;
				width: 100%;
				padding: 0 32px;
			`}
		>
			{children}
		</div>
	);
};
